<div class="order-status-header" *ngIf="params">
	<div class="order-status-header-item" [hidden]="!params.iconName">
		<mat-icon class="order-status-header-icon" [svgIcon]="params.iconName"></mat-icon>
	</div>
	<div class="order-status-header-item">
		<span class="ag-header-cell-text">{{ params.displayName }}</span>
	</div>
	<div class="order-status-header-item order-satus-header-value ag-theme-balham">
		<span class="ag-header-cell-text">{{ params.value | copoNumber: 'weight':'t' }}</span>
	</div>
</div>
